const BUSINESS_TYPES = [
  {
    label: "Agricultural Merchant / Farm Store",
    value: "Agricultural Merchant / Farm Store",
    id: "agricultural_merchant_farm_store",
  },
  {
    label: "Animal Shelter / Charity",
    value: "Animal Shelter / Charity",
    id: "animal_shelter_charity",
  },
  {
    label: "Backgrounder Lot",
    value: "Backgrounder Lot",
    id: "backgrounder_lot",
  },
  {
    label: "Beef Producer",
    value: "Beef Producer",
    id: "beef_producer",
  },
  { label: "Broilers", value: "Broilers", id: "broilers" },
  {
    label: "Buying Group",
    value: "Buying Group",
    id: "buying_group",
  },
  {
    label: "Calf Production",
    value: "Calf Production",
    id: "calf_production",
  },
  {
    label: "Calf Ranch/Developer",
    value: "Calf Ranch/Developer",
    id: "calf_ranch_developer",
  },
  { label: "Cattle Buyer", value: "Cattle Buyer", id: "cattle_buyer" },
  {
    label: "Contract Grower",
    value: "Contract Grower",
    id: "contract_grower",
  },
  { label: "Cooperative", value: "Cooperative", id: "cooperative" },
  {
    label: "สำนักงานบริษัท",
    value: "Corporate Office",
    id: "corporate_office",
  },
  {
    label: "Cow/Calf Operation",
    value: "Cow/Calf Operation",
    id: "cow_calf_operation",
  },
  {
    label: "Dairy Production",
    value: "Dairy Production",
    id: "dairy_production",
  },
  {
    label: "Distributor / Agent",
    value: "Distributor / Agent",
    id: "distributor_agent",
  },
  { label: "Feed Mill", value: "Feed Mill", id: "feed_mill" },
  { label: "Feedyard", value: "Feedyard", id: "feedyard" },
  {
    label: "Grower/Growyard",
    value: "Grower/Growyard",
    id: "grower_growyard",
  },
  { label: "Hatchery", value: "Hatchery", id: "hatchery" },
  {
    label: "Heifer Production",
    value: "Heifer Production",
    id: "heifer_production",
  },
  {
    label: "Layer Integration",
    value: "Layer Integration",
    id: "layer_integration",
  },
  { label: "Layers", value: "Layers", id: "layers" },
  { label: "Media", value: "Media", id: "media" },
  {
    label: "Milk Cooperative/Buyer",
    value: "Milk Cooperative/Buyer",
    id: "milk_cooperative_buyer",
  },
  {
    label: "Mixed/Other Producer",
    value: "Mixed/Other Producer",
    id: "mixed_other_producer",
  },
  {
    label: "Nutrient Supplier",
    value: "Nutrient Supplier",
    id: "nutrient_supplier",
  },
  {
    label: "Packer/Processor",
    value: "Packer/Processor",
    id: "packer_processor",
  },
  {
    label: "Pet Retail Outlet",
    value: "Pet Retail Outlet",
    id: "pet_retail_outlet",
  },
  { label: "Pharmacy", value: "Pharmacy", id: "pharmacy" },
  {
    label: "Poultry Breeder",
    value: "Poultry Breeder",
    id: "poultry_breeder",
  },
  {
    label: "Poultry Integrator",
    value: "Poultry Integrator",
    id: "poultry_integrator",
  },
  { label: "Sheep Producer", value: "Sheep Producer", id: "sheep_producer" },
  {
    label: "Stocker Operation",
    value: "Stocker Operation",
    id: "stocker_operation",
  },
  {
    label: "Stockyard/Salebarn",
    value: "Stockyard/Salebarn",
    id: "stockyard_salebarn",
  },
  { label: "Swine Producer", value: "Swine Producer", id: "swine_producer" },
  { label: "Turkeys", value: "Turkeys", id: "turkeys" },
  {
    label: "University / Education",
    value: "University / Education",
    id: "university_education",
  },
  {
    label: "คลินิกสัตวแพทย์",
    value: "Veterinary Practice",
    id: "veterinary_practice",
  },
  {
    label: "Wholesaler / Retailer",
    value: "Wholesaler / Retailer",
    id: "wholesaler_retailer",
  },
  { label: "Wool Buyer", value: "Wool Buyer", id: "wool_buyer" },
];

const FIELDS = {
  common: {
    errors: {
      required: "จำเป็น",
    },
  },
  salutation: {
    label: "คำนำหน้า",
    placeholder: "เลือกคำนำหน้า",
    errors: {
      required: "คำนำหน้าจำเป็นต้องกรอก",
      invalid: "เลือกคำนำหน้าที่ถูกต้อง",
    },
  },
  firstName: {
    label: "ชื่อ",
    placeholder: "สมชาย",
    errors: {
      required: "ชื่อจำเป็นต้องกรอก",
      minLength: "ชื่อต้องมี อย่างน้อย 2 อักขระ",
      maxLength: "ชื่อต้องมี ไม่เกิน 50 อักขระ",
    },
  },
  lastName: {
    label: "นามสกุล",
    placeholder: "ใจดี",
    errors: {
      required: "นามสกุลจำเป็นต้องกรอก",
      minLength: "นามสกุลต้องมี อย่างน้อย 2 อักขระ",
      maxLength: "นามสกุลต้องมี ไม่เกิน 50 อักขระ",
    },
  },
  email: {
    label: "อีเมล",
    placeholder: "somchai.jaidee@example.com",
    description: "กรุณากรอกที่อยู่อีเมลส่วนตัวของคุณ ไม่ใช่อีเมลที่ใช้ร่วมกัน",
    prefixWarningTitle: "ตรวจพบกล่องจดหมายที่ใช้ร่วมกัน",
    prefixWarningDescription:
      "เราแนะนำให้ใช้ที่อยู่อีเมลส่วนตัวเพื่อประสบการณ์ที่ดีกว่าและเป็นส่วนตัวมากขึ้น",
    errors: {
      required: "อีเมลจำเป็นต้องกรอก",
      invalidEmail: "กรุณากรอกที่อยู่อีเมลที่ถูกต้อง",
      emailAssociatedWithYourAccount:
        "อีเมลของคุณเชื่อมโยงกับบัญชีของคุณแล้วและไม่สามารถเปลี่ยนได้",
    },
  },
  confirmEmail: {
    label: "ยืนยันอีเมล",
    placeholder: "somchai.jaidee@example.com",
    errors: {
      required: "การยืนยันอีเมลจำเป็นต้องกรอก",
      invalidEmail: "กรุณากรอกที่อยู่อีเมลที่ถูกต้อง",
      emailMatchError: "อีเมลไม่ตรงกัน",
    },
  },
  password: {
    label: "รหัสผ่าน",
    placeholder: "กรอกรหัสผ่านของคุณ",
    errors: {
      required: "รหัสผ่านจำเป็นต้องกรอก",
    },
  },
  confirmPassword: {
    label: "ยืนยันรหัสผ่าน",
    placeholder: "ยืนยันรหัสผ่านของคุณ",
    errors: {
      required: "การยืนยันรหัสผ่านจำเป็นต้องกรอก",
      passwordMatchError: "รหัสผ่านไม่ตรงกัน",
    },
  },
  addressLine1: {
    label: "บรรทัดที่อยู่ 1",
    placeholder: "123 ถนนสุขุมวิท",
    errors: {
      required: "บรรทัดที่อยู่ 1จำเป็นต้องกรอก",
      minLength: "บรรทัดที่อยู่ 1 ต้องมีอย่างน้อย 5 ตัวอักษร",
      maxLength: "บรรทัดที่อยู่ 1 ต้องไม่เกิน 100 อักขระ",
    },
  },
  addressLine2: {
    label: "บรรทัดที่อยู่ 2",
    placeholder: "ห้อง 4B",
    errors: {
      required: "บรรทัดที่อยู่ 2จำเป็นต้องกรอก",
      maxLength: "บรรทัดที่อยู่ 2 ต้องไม่เกิน 100 อักขระ",
    },
  },
  city: {
    label: "เมือง",
    placeholder: "กรุงเทพ",
    errors: {
      required: "เมืองจำเป็นต้องกรอก",
      minLength: "เมืองต้องมีอย่างน้อย 2 อักขระ",
      maxLength: "เมืองต้องไม่เกิน 50 อักขระ",
    },
  },
  state: {
    label: "รัฐ",
    placeholder: "เลือกรัฐ",
    errors: {
      required: "รัฐจำเป็นต้องกรอก",
      invalid: "เลือกรัฐที่ถูกต้อง",
    },
  },
  jurisdiction: {
    label: "เขตอำนาจ",
    placeholder: "เลือกเขตอำนาจ",
    errors: {
      required: "เขตอำนาจจำเป็นต้องกรอก",
      invalid: "เขตอำนาจที่ถูกต้อง",
    },
  },
  zipCode: {
    label: "รหัสไปรษณีย์",
    placeholder: "00100",
    errors: {
      required: "รหัสไปรษณีย์จำเป็นต้องกรอก",
      invalid: "กรุณากรอกรหัสไปรษณีย์ที่ถูกต้อง",
    },
  },
  role: {
    label: "บทบาท",
    placeholder: "เลือกบทบาทของคุณ",
    errors: {
      required: "เลือกบทบาทของคุณ",
      invalid: "เลือกบทบาทที่ถูกต้อง",
    },
  },
  businessType: {
    label: "ประเภทธุรกิจ",
    placeholder: "เลือกประเภทธุรกิจ",
    errors: {
      required: "ประเภทธุรกิจจำเป็นต้องกรอก",
      invalid: "เลือกประเภทธุรกิจที่ถูกต้อง",
    },
  },
  businessName: {
    label: "ชื่อธุรกิจ",
    placeholder: "กรอกชื่อธุรกิจ",
    errors: {
      required: "ชื่อธุรกิจจำเป็นต้องกรอก",
      minLength: "ชื่อธุรกิจต้องมีอย่างน้อย 2 อักขระ",
      maxLength: "ชื่อธุรกิจต้องไม่เกิน 100 อักขระ",
    },
  },
  businessSearch: {
    label: "ค้นหาธุรกิจ:",
    addNewAccount: "เพิ่มบัญชีธุรกิจใหม่",
    canNotFindBusiness: "ห าธุรกิจของคุณไม่พบหรือ",
    guideline: "กรอกรหัสไปรษณีย์ของคุณ จากนั้นเลือกจากรายการด้านล่าง",
    guidelineForNameSearch: "กรอกชื่อธุรกิจแบบเต็ม จากนั้นเลือกจากรายการ",
    placeholder: "คุณทำงานที่ไหน?",
    noResults: "ไม่พบผลลัพธ์",
    searching: "กำลังค้นหา...",
    selectedBusinessHeading: "ธุรกิจที่เลือก:",
    selectedBusinessNotCorrect: "ไม่ถูกต้องหรือ?",
    selectedBusinessTryAgain: "ลองอีกครั้ง",
    selectedBusinessDismiss: "ยกเลิกธุรกิจ",
    resultsFound: {
      singular: "พบ 1 ธุรกิจ",
      plural: "พบหลายธุรกิจ",
    },
    errors: {
      network:
        "มีปัญหาในการเชื่อมต่อกับบริการค้นหาธุรกิจ กรุณาลองอีกครั้งในภายหลัง",
    },
  },
  explicitConsent: {
    label:
      "การเลือกช่องนี้ ข้าพเจ้ายอมรับข้อกำหนดและเงื่อนไขของ Elanco และยืนยันว่า Elanco เก็บรวบรวมและประมวลผลข้อมูลส่วนบุคคลของข้าพเจ้าตามนโยบายความเป็นส่วนตัวของ Elanco",
    errors: {
      required: "จำเป็นต้องให้ความยินยอมอย่างชัดเจน",
    },
  },
  telephone: {
    label: "โทรศัพท์ส่วนตัว",
    placeholder: "กรอกหมายเลขโทรศัพท์ส่วนตัวของคุณ",
    dialCodeLabel: "รหัส",
    dialCodePlaceholder: "ค้นหาประเทศ…",
    errors: {
      invalid: "กรุณากรอกหมายเลขโทรศัพท์ที่ถูกต้อง",
    },
  },
  businessTelephone: {
    label: "โทรศัพท์ธุรกิจ",
    placeholder: "กรอกหมายเลขโทรศัพท์ธุรกิจ",
    dialCodeLabel: "รหัส",
    dialCodePlaceholder: "ค้นหาประเทศ…",
    errors: {
      invalid: "กรุณากรอกหมายเลขโทรศัพท์ที่ถูกต้อง",
    },
  },
  professionalNumber: {
    label: "หมายเลขวิชาชีพ",
    placeholder: "1234567",
    errors: {
      required: "กรุณากรอกหมายเลขวิชาชีพ",
      maxLength: "ข้อมูลที่ป้อนเกินขีดจำกัดตัวอักษร",
    },
  },
  addressSearch: {
    errors: {
      required: "ฟิลด์นี้จำเป็น",
    },
  },
  businessSearchField: {
    errors: {
      required: "ฟิลด์นี้จำเป็น",
    },
  },
  checkbox: {
    errors: {
      required: "ฟิลด์นี้จำเป็น",
    },
  },
  checkboxGroup: {
    errors: {
      required: "ฟิลด์นี้จำเป็น",
    },
  },
  combobox: {
    errors: {
      required: "ฟิลด์นี้จำเป็น",
    },
  },
  datePicker: {
    errors: {
      required: "ฟิลด์นี้จำเป็น",
    },
  },
  dateRange: {
    errors: {
      required: "ฟิลด์นี้จำเป็น",
    },
  },
  dateTime: {
    errors: {
      required: "ฟิลด์นี้จำเป็น",
    },
  },
  emailField: {
    errors: {
      required: "ฟิลด์นี้จำเป็น",
    },
  },
  fileInput: {
    errors: {
      required: "เลือกไฟล์",
    },
  },
  number: {
    errors: {
      required: "กรุณากรอกตัวเลข",
      minValue: "กรุณากรอกค่าที่มากกว่าค่าต่ำสุด",
      maxValue: "กรุณากรอกค่าที่น้อยกว่าค่าสูงสุด",
    },
  },
  passwordField: {
    errors: {
      required: "ฟิลด์นี้จำเป็น",
    },
  },
  rangeSlider: {
    errors: {
      required: "ฟิลด์นี้จำเป็น",
    },
  },
  select: {
    errors: {
      required: "ฟิลด์นี้จำเป็น",
    },
  },
  telephoneField: {
    errors: {
      required: "กรอกตัวเลขเท่านั้น",
      invalidTelephone: "กรุณากรอกหมายเลขโทรศัพท์ที่ถูกต้อง",
      invalidFormat: "รูปแบบหมายเลขไม่ถูกต้อง",
    },
  },
  text: {
    errors: {
      required: "ใช้เฉพาะตัวอักษร (A-Z) ตัวเลข (0-9) และไม่มีสัญลักษณ์",
      maxLength: "ข้อมูลที่ป้อนเกินขีดจำกัดตัวอักษร",
      minLength: "ข้อมูลที่ป้อนต้องมีอย่างน้อย 2 อักขระ",
    },
  },
  textarea: {
    characters: "ตัวอักษร",
  },
  time: {
    errors: {
      required: "ฟิลด์นี้จำเป็น",
    },
  },
  form: {
    errors: {
      generic: "เกิดข้อผิดพลาดในการส่งแบบฟอร์ม กรุณาลองอีกครั้ง",
      reportAnIssue: "รายงานปัญหา",
      configuration: "ข้อผิดพลาดการกำหนดค่า",
      noFormQuestionsAvailable: "ไม่มีรายการแบบฟอร์ม",
      formComponentLoad:
        "ไม่สามารถโหลดส่วนประกอบแบบฟอร์มได้เนื่องจากฟิลด์ที่ไม่รองรับ",
      code: "รหัส",
      type: "ประเภท",
      missingRequiredFields:
        "แบบฟอร์มขาดฟิลด์ที่จำเป็น (อีเมล และ/หรือ ความยินยอม) กรุณาติดต่อผู้ดูแลระบบเพื่อแก้ไขการกำหนดค่าแบบฟอร์ม",
    },
  },
};

const ROLES = [
  { value: "Academic", label: "Academic", id: "academic" },
  {
    value: "Animal Welfare - Other",
    label: "Animal Welfare - Other",
    id: "animal_welfare_other",
  },
  {
    value: "Animal Welfare - Retail Staff",
    label: "Animal Welfare - Retail Staff",
    id: "animal_welfare_retail_staff",
  },
  {
    value: "Animal Welfare - Vet",
    label: "สวัสดิการสัตว์ - สัตวแพทย์",
    id: "animal_welfare_vet",
  },
  {
    value: "Animal Welfare - Vet Nurse",
    label: "Animal Welfare - Vet Nurse",
    id: "animal_welfare_vet_nurse",
  },
  {
    value: "Animal Welfare - Volunteer",
    label: "Animal Welfare - Volunteer",
    id: "animal_welfare_volunteer",
  },
  {
    value: "Beef / Feedlot Extension",
    label: "Beef / Feedlot Extension",
    id: "beef_feedlot_extension",
  },
  {
    value: "Beef Producer",
    label: "Beef Producer",
    id: "beef_producer",
  },
  { value: "Breeder", label: "Breeder", id: "breeder" },
  {
    value: "Business Administrator / Receptionist",
    label: "Business Administrator / Receptionist",
    id: "business_administrator_receptionist",
  },
  {
    value: "Business Owner / Partner",
    label: "Business Owner / Partner",
    id: "business_owner_partner",
  },
  {
    value: "Consulting Nutritionist",
    label: "Consulting Nutritionist",
    id: "consulting_nutritionist",
  },
  {
    value: "Corporate Employee Non DVM",
    label: "Corporate Veterinary Employee (non-hospital)",
    id: "corporate_employee_non_dvm",
  },
  {
    value: "Dairy Producer",
    label: "Dairy Producer",
    id: "dairy_producer",
  },
  { value: "Distributor", label: "Distributor", id: "distributor" },
  {
    value: "Distributor Rep, Field Based",
    label: "Distributor Rep, Field Based",
    id: "distributor_rep_field_based",
  },
  {
    value: "Distributor Rep, Inside",
    label: "Distributor Rep, Inside",
    id: "distributor_rep_inside",
  },
  {
    value: "Educational Institution - Highschool Student",
    label: "Educational Institute - Highschool Student",
    id: "educational_institution_highschool_student",
  },
  {
    value: "Educational Institution - TAFE Student",
    label: "Educational Institute - TAFE Student",
    id: "educational_institution_tafe_student",
  },
  {
    value: "Educational Institution - University Student",
    label: "Educational Institute - University Student",
    id: "educational_institution_university_student",
  },
  { value: "Groomer", label: "Groomer", id: "groomer" },
  {
    value: "Medical / Clinic Director",
    label: "Medical/Clinic Director",
    id: "medical_clinic_director",
  },
  {
    value: "Nutrition / Feed Sales",
    label: "Nutrition / Feed Sales",
    id: "nutrition_feed_sales",
  },
  {
    value: "Nutritional Professional",
    label: "Nutritional Professional",
    id: "nutritional_professional",
  },
  { value: "Nutritionist", label: "Nutritionist", id: "nutritionist" },
  {
    value: "Office / Practice Manager",
    label: "Office/Practice Manager",
    id: "office_practice_manager",
  },
  { value: "OTC Retailer", label: "OTC Retailer", id: "otc_retailer" },
  { value: "Pharmacist", label: "Pharmacist", id: "pharmacist" },
  {
    value: "Pharmacy - Staff",
    label: "Pharmacy - Staff",
    id: "pharmacy_staff",
  },
  { value: "Pig Producer", label: "Pig Producer", id: "pig_producer" },
  {
    value: "Poultry Producer",
    label: "Poultry Producer",
    id: "poultry_producer",
  },
  {
    value: "Practice Owner, Non DVM",
    label: "Practice Owner, Non DVM",
    id: "practice_owner_non_dvm",
  },
  {
    value: "Receptionist / Client Service",
    label: "Receptionist/Client Service",
    id: "receptionist_client_service",
  },
  {
    value: "Reseller Store - Staff",
    label: "Reseller Store - Staff",
    id: "reseller_store_staff",
  },
  { value: "SQP", label: "RAMA / SQP", id: "sqp" },
  { value: "Student RAMA", label: "Student RAMA", id: "student_rama" },
  {
    value: "Tierarzt/ Tierärztin",
    label: "สัตวแพทย์",
    id: "tierarzt_tierarztin",
  },
  { value: "Trainer", label: "Trainer", id: "trainer" },
  { value: "Veterinarian", label: "สัตวแพทย์", id: "veterinarian" },
  {
    value: "Veterinarian, Practice Owner",
    label: "สัตวแพทย์, เจ้าของคลินิก",
    id: "veterinarian_practice_owner",
  },
  {
    value: "Veterinary Assistant",
    label: "ผู้ช่วยสัตวแพทย์",
    id: "veterinary_assistant",
  },
  {
    value: "Veterinary Nurse",
    label: "Veterinary Nurse",
    id: "veterinary_nurse",
  },
  {
    value: "Veterinary Practice - Other",
    label: "คลินิกสัตวแพทย์ - อื่นๆ",
    id: "veterinary_practice_other",
  },
  {
    value: "Veterinary Practice - Vet",
    label: "คลินิกสัตวแพทย์ - สัตวแพทย์",
    id: "veterinary_practice_vet",
  },
  {
    value: "Veterinary Practice - Vet Nurse",
    label: "คลินิกสัตวแพทย์ - พยาบาลสัตว์",
    id: "veterinary_practice_vet_nurse",
  },
  {
    value: "Veterinary Specialist",
    label: "ผู้เชี่ยวชาญสัตวแพทย์",
    id: "veterinary_specialist",
  },
  {
    value: "Veterinary Student",
    label: "Veterinary Student",
    id: "veterinary_student",
  },
  {
    value: "Veterinary Surgeon",
    label: "สัตวแพทย์",
    id: "veterinary_surgeon",
  },
  {
    value: "Veterinary Technician",
    label: "Veterinary Technician",
    id: "veterinary_technician",
  },
  { value: "Wholesaler", label: "Wholesaler", id: "wholesaler" },
];

const SALUTATIONS = [
  {
    label: "Dr.",
    value: "Dr.",
    id: "dr",
  },
  {
    label: "นาย",
    value: "M.",
    id: "m",
  },
  {
    label: "Miss",
    value: "Miss",
    id: "miss",
  },
  {
    label: "นาย",
    value: "Mr.",
    id: "mr",
  },
  {
    label: "นาง",
    value: "Mrs.",
    id: "mrs",
  },
  {
    label: "นาง",
    value: "Ms.",
    id: "ms",
  },
  {
    label: "Mx.",
    value: "Mx.",
    id: "mx",
  },
  {
    label: "ศาสตราจารย์",
    value: "Professor",
    id: "professor",
  },
];

export { BUSINESS_TYPES, FIELDS, ROLES, SALUTATIONS };
